import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '@contexts/authContext';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useRedirectParam } from '../../hooks/useRedirectParam';

const GoogleLoginButton = () => {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const { consumeRedirect } = useRedirectParam();
  const [isLoading, setIsLoading] = useState(false);


  const handleGoogleSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const idToken = credentialResponse.credential;
      const user = await loginWithGoogle(idToken);

      // if user doesn't have user type, redirect to role selection page
      if (!user?.user_type) {
        return navigate('/complete-profile');
      }
      const storedRedirect = consumeRedirect();
      if (storedRedirect) {
        navigate(storedRedirect);
      } else {
        navigate(`/${user.user_type}/dashboard`);
      }
    } catch (error) {
      console.error('Google login error:', error);
      toast.error(typeof error === 'string' ? error : 'Google login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    console.error('Google login failed');
    toast.error('Google login failed. Please try again.');
  };

  return (
    <div className="w-full">
      {isLoading ? (
        <button
          type="button"
          disabled
          className="w-full h-10 rounded-md border border-gray-300 bg-gray-100 text-gray-600 text-sm font-medium flex items-center justify-center gap-2 cursor-not-allowed"
        >
          <span className="h-4 w-4 rounded-full border-2 border-gray-400 border-t-transparent animate-spin" />
          Signing in with Google...
        </button>
      ) : (
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          useOneTap
          theme="outline"
          size="large"
          text="continue_with"
          shape="rectangular"
        />
      )}
    </div>
  );
};

export default GoogleLoginButton;
